@if (showTitle) {
  <app-field-label
    [props]="position"
    [useAttributeDescription]="false"
  ></app-field-label>
}
@if (position.questionDescription) {
  <div
    class="search-label"
    [id]="position.id + '-description'"
    [innerHTML]="position.questionDescription | safeHtml"
  ></div>
}
@if (selectedPersons.length) {
  <ul class="selected-persons">
    @for (person of selectedPersons; track person.id) {
      <li class="selected-person" [class.duplicate]="isPersonInvalid(person)">
        <div class="selected-person-row">
          <app-position-search-result
            class="selected-person-result"
            [person]="person"
          ></app-position-search-result>
          @if (!position.isReadOnly) {
            <button
              mat-icon-button
              (click)="removePerson(person)"
              [attr.aria-label]="
                'Remove ' + person.firstName + ' ' + person.lastName
              "
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
        @if (seatFieldsVisible(person.id)) {
          <div class="seat-fields" [id]="seatFieldsId(person.id)">
            <!-- label from the field's name: tracked field definitions rarely set a description -->
            <attributes-editor
              [dataSource]="seatFieldDataSource(person.id)"
              [useAttributeDescription]="false"
              (fieldUpdated)="onSeatFieldChanged(person.id)"
              (blurred)="onSeatFieldChanged(person.id)"
            ></attributes-editor>
          </div>
        }
      </li>
    }
  </ul>
}

<div class="search-container" (focusout)="onSearchFocusOut($event)">
  @if (!position.isReadOnly) {
    <mat-form-field appearance="outline" class="search-field">
      <input
        matInput
        [id]="position.id"
        [formControl]="searchControl"
        placeholder="Type to search..."
        role="combobox"
        autocomplete="off"
        aria-autocomplete="list"
        [attr.aria-controls]="listboxId"
        [attr.aria-label]="searchInputLabel"
        [attr.aria-expanded]="isDropdownOpen"
        [attr.aria-activedescendant]="activeOptionId"
        [attr.aria-describedby]="searchInputDescribedBy"
        (keydown)="onSearchKeydown($event)"
        (focus)="onInputFocus()"
      />

      <mat-hint [ngClass]="{ invalid: isInvalid }">
        {{ selectedPersons.length }}
        @if (selectedPersons.length < position.minSeatCount) {
          of {{ position.minSeatCount }}
        }
        selected
        @if (isInvalid) {
          @if (position.minSeatCount - selectedPersons.length === 1) {
            <span>. Need 1 more person in this position</span>
          } @else {
            <span
              >. Need {{ position.minSeatCount - selectedPersons.length }} more
              people in this position</span
            >
          }
        }
      </mat-hint>
    </mat-form-field>
  }
  @if (isDropdownOpen) {
    <div class="search-dropdown" (mousedown)="$event.preventDefault()">
      <!-- a listbox may only contain options, so the status text and button sit outside it -->
      <div
        role="listbox"
        [id]="listboxId"
        [attr.aria-label]="'People matching your search for ' + position.name"
      >
        @for (person of searchResults; track person.id; let i = $index) {
          <div
            class="search-option"
            role="option"
            [id]="optionId(i)"
            [class.active]="i === activeOptionIndex"
            [attr.aria-selected]="i === activeOptionIndex"
            (click)="selectPerson(person)"
          >
            <app-position-search-result
              [person]="person"
            ></app-position-search-result>
          </div>
        }
      </div>
      <!-- announced by the polite region below, so hidden here to avoid saying it twice -->
      @if (isLoading) {
        <div class="search-option search-option--disabled" aria-hidden="true">
          Loading...
        </div>
      }
      @if (showLoadMore) {
        <button
          type="button"
          class="search-option search-option--load-more"
          (click)="loadMore()"
        >
          Load more people...
        </button>
      }
      @if (
        !isLoading &&
        searchResults.length === 0 &&
        searchControl.value?.length >= 2
      ) {
        <div class="search-option search-option--disabled" aria-hidden="true">
          No results found
        </div>
      }
    </div>
  }
</div>

@if (hasDuplicatePersons) {
  <p class="duplicate-error" [id]="'duplicate-' + position.id">
    A person is already selected in another position
  </p>
}

<div aria-live="polite" class="cdk-visually-hidden">
  {{ resultsAnnouncement }}
</div>
<div aria-live="polite" class="cdk-visually-hidden">
  {{ selectionAnnouncement }}
</div>
